import type { ExperimentDefinition } from './types';

export function validateExperimentRatios(
  experiment: ExperimentDefinition,
): void {
  const total = Object.values(experiment.variants).reduce(
    (sum, { ratio }) => sum + ratio,
    0,
  );

  if (Math.abs(total - 1) > Number.EPSILON) {
    throw new Error(
      `Experiment "${experiment.name}" variant ratios must sum to 1.0 (got ${total})`,
    );
  }
}

function validateExperimentVariants(experiment: ExperimentDefinition): void {
  if (!isVariantValid(experiment, experiment.controlVariant)) {
    throw new Error(
      `Experiment "${experiment.name}" controlVariant "${experiment.controlVariant}" is not defined in variants`,
    );
  }

  if (
    experiment.botVariant &&
    !isVariantValid(experiment, experiment.botVariant)
  ) {
    throw new Error(
      `Experiment "${experiment.name}" botVariant "${experiment.botVariant}" is not defined in variants`,
    );
  }

  for (const variantName of Object.keys(experiment.variants)) {
    if (!variantName.trim()) {
      throw new Error(
        `Experiment "${experiment.name}" has an empty variant key`,
      );
    }
  }
}

function isVariantValid(
  experiment: ExperimentDefinition,
  variant: string,
): boolean {
  return variant in experiment.variants;
}

export function validateExperiments(experiments: ExperimentDefinition[]): void {
  const names = new Set<string>();

  experiments.forEach((experiment) => {
    if (names.has(experiment.name)) {
      throw new Error(`Duplicate experiment name "${experiment.name}"`);
    }
    names.add(experiment.name);
    validateExperimentRatios(experiment);
    validateExperimentVariants(experiment);
  });
}
